import { createSelector } from 'reselect'

export const getSimilarWords = createSelector(
  state => state && state.categories && state.categories.similarWords ? state.categories.similarWords : null,
  similarWords => similarWords
)
